import { useTranslation } from 'react-i18next'

import { StorefrontIcon, UserCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { CopyToClipBoard, ReturnsPortalIcon, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StoreInfo = ({ info }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text tag="h1" type="titleS" customStyles={{ fontWeight: 700 }}>
        {info?.name}
      </Text>
      <div>
        <CopyToClipBoard
          value={`https://${info?.selectedStore?.domain}`}
          label={t('Tienda online')}
          fullWidth
          Icon={() => <StorefrontIcon size={24} />}
        />
        {info?.selectedStore?.returns_portal_url && (
          <CopyToClipBoard
            value={info?.selectedStore?.returns_portal_url}
            label={t('Portal devoluciones')}
            fullWidth
            Icon={() => <ReturnsPortalIcon color={theme.colors.outline.default} />}
          />
        )}
        {info?.selectedStore?.customers_portal_url && (
          <CopyToClipBoard
            value={info?.selectedStore?.customers_portal_url}
            label={t('Panel de cliente')}
            fullWidth
            Icon={() => <UserCircleIcon size={24} />}
          />
        )}
      </div>
    </Styles.Container>
  )
}

export default StoreInfo
